import React from 'react';
import { useTranslation } from 'react-i18next';

import { contact } from '../../constant/contact';

function FooterAddress() {
    const [t] = useTranslation('footer');

    const onClickAddress = () => {
        window.open(`https://google.ca/maps/search/${contact.ADDRESS.value}`, '_blank');
    };

    return (
        <div className={'sm:px-8'}>
            <p className={'mb-3 text-base font-bold uppercase tracking-wider text-white'}>{t('address')}</p>

            <p
                className={'cursor-pointer text-base text-white hover:opacity-50'}
                onClick={onClickAddress}
            >
                {contact.ADDRESS.value}
            </p>
        </div>
    );
}

export default FooterAddress;
